import ACTIONS, { FETCH_STATUS } from '../app.constants';
import { CommentList, Form, Violation, Comment, ViolationList } from '../modules/application/types';
import { LimitAndSkipData } from '../modules/calendar/types';

export const getViolationDetail = {
    pending: {
        type: ACTIONS.GET_VIOLATION_DETAIL_BY_ID.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (violation: Violation, editForm: Form | undefined) => ({
        type: ACTIONS.GET_VIOLATION_DETAIL_BY_ID.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data: {
            violation,
            editForm,
        },
    }),

    error: (error: Error) => ({
        type: ACTIONS.GET_VIOLATION_DETAIL_BY_ID.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const updateViolation = {
    pending: {
        type: ACTIONS.UPDATE_VIOLATION.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: Violation) => ({
        type: ACTIONS.UPDATE_VIOLATION.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.UPDATE_VIOLATION.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const addViolationComment = {
    pending: {
        type: ACTIONS.ADD_VIOLATION_COMMENT.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: Comment) => ({
        type: ACTIONS.ADD_VIOLATION_COMMENT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.ADD_VIOLATION_COMMENT.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const getViolationCommentList = {
    pending: {
        type: ACTIONS.VIOLATION_COMMENT_LIST.PENDING,
    },
    success: (data: CommentList, paginationData: LimitAndSkipData) => ({
        type: ACTIONS.VIOLATION_COMMENT_LIST.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
        paginationData,
    }),
    error: (error: Error) => ({
        type: ACTIONS.VIOLATION_COMMENT_LIST.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getOpenedViolations = {
    pending: {
        type: ACTIONS.GET_OPENED_VIOLATIONS.PENDING,
    },
    success: (data: ViolationList) => ({
        type: ACTIONS.GET_OPENED_VIOLATIONS.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_OPENED_VIOLATIONS.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const closeBulkViolations = {
    pending: {
        type: ACTIONS.CLOSE_BULK_VIOLATIONS.PENDING,
    },
    success: (data: ViolationList) => ({
        type: ACTIONS.CLOSE_BULK_VIOLATIONS.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.CLOSE_BULK_VIOLATIONS.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const closeBulkViolationsBegin = (data: string[], licenseId: string) => {
    return {
        type: ACTIONS.CLOSE_BULK_VIOLATIONS_BEGIN,
        payload: { data, licenseId },
    };
};
export const getOpenedViolationsBegin = (licenseId: string) => {
    return {
        type: ACTIONS.GET_OPENED_VIOLATIONS_BEGIN,
        payload: { licenseId },
    };
};

export const updateViolationBegin = (data: Violation, violationId: string) => {
    return {
        type: ACTIONS.UPDATE_VIOLATION_BEGIN,
        payload: { data, violationId },
    };
};

export const getViolationDetailsBegin = (id: string) => {
    return {
        type: ACTIONS.GET_VIOLATION_DETAIL_BY_ID_BEGIN,
        payload: { id },
    };
};

export const addViolationCommentBegin = (data: string, violationId: string) => {
    return {
        type: ACTIONS.ADD_VIOLATION_COMMENT_BEGIN,
        payload: { data, violationId },
    };
};

export const getViolationCommentListBegin = (id: string, paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.VIOLATION_COMMENT_LIST_BEGIN,
        payload: { id },
        paginationData,
    };
};
